/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  encryptSecretKey = 'test';
  oneLinkKey: string = '110947D&#s83n0ln2207j3n';

  encryptData(data: any, ignoreCharSpecial?: boolean): string {
    // tslint:disable-next-line:variable-name
    const _key = CryptoJS.enc.Utf8.parse(this.encryptSecretKey);
    // tslint:disable-next-line:variable-name
    const _iv = CryptoJS.enc.Utf8.parse(this.encryptSecretKey);
    const opt = Object.assign({
      mode: CryptoJS.mode.ECB
    }, { iv: _iv });

    try {
      const encryptCrypto = CryptoJS.AES.encrypt(JSON.stringify(data), _key, opt).toString();
      // ignore char : + / =;
      const encrypt = ignoreCharSpecial ?
        encryptCrypto
          .replace(/\+/g, 'p1L2u3S')
          .replace(/\//g, 's1L2a3S4h')
          .replace(/=/g, 'e1Q2u3A4l') :
        encryptCrypto;
      return encrypt;
    } catch (e) {
      return '';
      // console.log(e);
    }
  }


  newEncryptData(data: any) {
    return CryptoJS.AES.encrypt(JSON.stringify(data), CryptoJS.MD5('t3Lk0MseL.c0m321'), {
      mode: CryptoJS.mode.ECB,
      keySize: 32,
      padding: CryptoJS.pad.Pkcs7,
      format: CryptoJS.format.OpenSSL
    }).toString();
  }

  decryptData(data: any, ignoreCharSpecial?: boolean) {
    // tslint:disable-next-line:variable-name
    const _key = CryptoJS.enc.Utf8.parse(this.encryptSecretKey);
    // tslint:disable-next-line:variable-name
    const _iv = CryptoJS.enc.Utf8.parse(this.encryptSecretKey);
    const opt = Object.assign({
      mode: CryptoJS.mode.ECB
    }, { iv: _iv });

    try {
      data = ignoreCharSpecial ?
        data
          .replace(/p1L2u3S/g, '+' )
          .replace(/s1L2a3S4h/g, '/')
          .replace(/e1Q2u3A4l/g, '=') : data;
      const bytes = CryptoJS.AES.decrypt(data, _key, opt);
      if (bytes.toString()) {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      return data;
    } catch (e) {
      // console.log(e);
    }
  }
}
